import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { History } from 'history';

import reducerRegistry from '../registries/ReducerRegistry';
import { xsellBannerReducers } from '@axa-asia/emma-prismic-xsell-banners';

export default (history: History) =>
  combineReducers({
    router: connectRouter(history),
    ...reducerRegistry.getReducers(),
    ...xsellBannerReducers,
  });
